import NoResults, { NoResultsProps } from "components/Organisms/NoResults"
import React from "react"

interface ErrorProps extends NoResultsProps {
  /**
   * The default error message
   * @default "Unable to fetch the results"
   */
  message?: string
}
const Error = ({
  icon,
  message,
  children,
  className,
  action,
  ...otherProps
}: ErrorProps) => {
  return (
    <div className="vt-non-ideal-state-container">
      <NoResults
        className={className}
        icon={icon}
        action={action}
        title={message}
        {...otherProps}
      >
        {children}
      </NoResults>
    </div>
  )
}

Error.defaultProps = {
  icon: "error",
  message: "Unable to fetch the results",
}

export default Error
